import {makeUseRecaptcha} from '@practicegenius/pg-ui/src/hooks/makeUseRecaptcha';
import log from '../../utils/logger';
import {useSyncSession} from '../queries/global';
import ServiceBrand from '../../utils/ServiceBrand';

export const useRecaptcha = makeUseRecaptcha({
  logger: log,
  // This works because it is in a callback. The eslint rule can't validate this
  recaptchaSiteKey: ServiceBrand.data.googleRecaptchaSiteKey,
  useSyncSession,
});
